export default {
  path: "customer",
  component: (resolve) => require(["@/views/Customer/Index"], resolve),
  name: "CustomerIndex",
  hidden: true,
  meta: {},
  children: [
    {
      path: "order",
      component: () =>
        import(
          /* webpackChunkName: "customer-order" */ "@/views/Customer/Order"
        ),
      name: "CustomerOrder",
      meta: { title: "我的订单", topbarHidden: false },
    },
    {
      path: "pay-result",
      component: () =>
        import(
          /* webpackChunkName: "customer-paysuccess" */ "@/views/Customer/PaySuccess"
        ),
      name: "PaySuccess",
      meta: { title: "我的订单", topbarHidden: true },
    },
  ],
};
